module.exports = __webpack_public_path__ + "static/circle-2-53fbc00b5db7c3a7f8b152fa3e877822.jpg";